import { useFormContext, useFormState } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import FormCheckbox from "../../shared/FormCheckbox";
import FormInputText from "../../shared/FormInputText";
import FormSelect from "../../shared/FormSelect";
import { getBillingCycles } from "../../../utils/apiUtils";
import { USA_STATES } from "../../../utils/constants";

const step = 3;
const TopAccountStepThree = ({ activeStep }) => {
    const { control, register, setValue, getValues } = useFormContext();
    const { errors } = useFormState({ control });

    const { data: billingCycles } = useQuery({
        queryKey: ['getBillingCycles'],
        queryFn: () => getBillingCycles(),
        select: (data) => data?.rows.map((entry) => {
            return { value: entry.billingCycleFactKey, label: entry.billingCycleName }})
    });
    
    if (activeStep !== step) return null;

    const onSelectedCheckbox = async (checked) => {
        if (checked) {
            const topAccount = getValues();
            setValue('ignoreBillingAddressCheck', topAccount.ignorePrimaryAddressCheck);
            setValue('billingAddress1', topAccount.primaryAddress1 ?? '', { shouldValidate: true });
            setValue('billingAddress2', topAccount.primaryAddress2 ?? '');
            setValue('billingAddress3', topAccount.primaryAddress3 ?? '');
            setValue('billingAddressCity', topAccount.primaryAddressCity ?? '', { shouldValidate: true });
            setValue('billingAddressState', topAccount.primaryAddressState, { shouldValidate: true });
            setValue('billingAddressZip', topAccount.primaryAddressZip ?? '', { shouldValidate: true });
        } else {
            resetField('ignoreBillingAddressCheck');
            resetField('billingAddress1');
            resetField('billingAddress2');
            resetField('billingAddress3');
            resetField('billingAddressCity');
            resetField('billingAddressState');
            resetField('billingAddressZip');

            await trigger([
                'billingAddress1',
                'billingAddressCity',
                'billingAddressState',
                'billingAddressZip'
            ]);
        }
    }

    return (
        <div style={{ width: "50%" }}>
            <FormSelect
                label={'Billing Cycle Name'}
                name={'billingCycle'}
                control={control}
                options={billingCycles}
                errors={errors}
                placeholder="Name"
            />
            <FormCheckbox
                label={'Copy Primary Correspondence Address'}
                name={'copyPrimaryCorrespondence'}
                control={control}
                onSelectedHandler={onSelectedCheckbox}
            />
            <FormCheckbox
                label={'Ignore Address Check'}
                name={'ignoreBillingAddressCheck'}
                control={control}
            />
            <br />
            <FormInputText label={'Premium Billing - Address Line 1'} register={register} name={'billingAddress1'} errors={errors} placeholder="Address" />
            <FormInputText label={'Premium Billing - Address Line 2'} register={register} name={'billingAddress2'} errors={errors} placeholder="Address (optional)" />
            <FormInputText label={'Premium Billing - Address Line 3'} register={register} name={'billingAddress3'} errors={errors} placeholder="Address (optional)" />
            <FormInputText label={'Premium Billing - Address City'} register={register} name={'billingAddressCity'} errors={errors} placeholder="City" />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2rem' }}>
                <FormSelect
                    label={'Premium Billing - Address State'}
                    name={'billingAddressState'}
                    control={control}
                    options={USA_STATES}
                    errors={errors}
                    placeholder="Select a state"
                />
                <FormInputText label={'Premium Billing - Address Zip'} register={register} name={'billingAddressZip'} errors={errors} placeholder="Zip code" />
            </div>
        </div>
    );
};

export default TopAccountStepThree;
